import axios from 'axios';

// API_TOKEN is not used in this client-side file, it's likely for a backend service.
// const API_TOKEN = 'aDjyTb2SDE1wgdf!xIj5OWynKkW4%mHRurFV.UscZMSO#6muhq6OzDzM7BCdCSzT';
// const HELCIM_API_URL = 'https://api.helcim.com/v2/helcim-pay/initialize'; // This is also likely for backend

export const initializeHelcimPayCheckout = async ({
  selectedCountry,
  total,
}) => {
  try {
    // Normalize the selectedCountry string for robust comparison
    const normalizedCountry = selectedCountry ? selectedCountry.toLowerCase().trim() : '';

    let currency;
    // Check for various forms of "Canada"
    if (
      normalizedCountry === 'canada' ||
      normalizedCountry === 'ca' ||
      normalizedCountry === 'can'
    ) {
      currency = 'CAD';
    } else if (
      normalizedCountry === 'united states' ||
      normalizedCountry === 'us' ||
      normalizedCountry === 'usa'
    ) {
      currency = 'USD';
    }
    // Add other countries and their currencies as needed
    else if (
      normalizedCountry === 'tunisia' ||
      normalizedCountry === 'tn'
    ) {
      currency = 'TND';
    }
    // Default currency if no match is found (e.g., for unknown countries)
    else {
      currency = 'USD'; // Or a default currency that makes sense for your business
    }

    console.log(`Initializing Helcim payment for ${selectedCountry} (normalized: ${normalizedCountry}) with total ${total} and determined currency ${currency}`);

    const response = await axios.post('https://freezepix-database-server-c95d4dd2046d.herokuapp.com/api/initialize-payment', {
      selectedCountry, // Send the original selectedCountry to the backend
      total,
      currency // Pass the determined currency to your backend
    });

    return {
      checkoutToken: response.data.checkoutToken,
      secretToken: response.data.secretToken
    };
  } catch (error) {
    console.error('Helcim initialization error:', error);
    throw new Error('Failed to initialize Helcim payment: ' + (error.response?.data?.message || error.message));
  }
};
